/**
 * Self-generated identicons — replaces api.dicebear.com (which rate-limits;
 * any surface rendering many avatars at once got 429s).
 *
 * Deterministic: the same seed always produces the same 5×5 symmetric pixel
 * pattern + colour, generated locally as a compact SVG data-URI (~300 chars).
 * No network, no rate limits, works offline, renders in any <img src>.
 *
 * The SAME algorithm lives in muuzbox-reports-admin/src/utils/identicon.js —
 * keep them in sync so a guest's avatar matches across every app.
 */

export const identiconDataUri = (seed) => {
  const s = String(seed || 'muuzbox');
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  // xorshift32 PRNG seeded by the hash. NOTE: cell decisions must come from
  // well-mixed HIGH bits — an earlier version tested the low bit after an
  // odd-constant multiply, and odd multiplication never changes the low bit,
  // which collapsed every avatar into one of just TWO shapes.
  let s2 = h || 1;
  const rnd = () => {
    s2 ^= s2 << 13; s2 >>>= 0;
    s2 ^= s2 >>> 17;
    s2 ^= s2 << 5; s2 >>>= 0;
    return s2;
  };

  const hue = rnd() % 360;
  const sat = 55 + (rnd() % 35);   // 55–89%
  const lit = 50 + (rnd() % 18);   // 50–67%

  let d = '';
  let cells = 0;
  for (let y = 0; y < 5; y++) {
    for (let x = 0; x < 3; x++) {
      // ~52% fill from bits 8-23 — the classic identicon density.
      if ((rnd() >>> 8) % 100 < 52) {
        cells++;
        d += `M${x} ${y}h1v1H${x}z`;
        if (x < 2) d += `M${4 - x} ${y}h1v1H${4 - x}z`;
      }
    }
  }
  if (cells < 3) d += 'M2 2h1v1H2zM1 1h1v1H1zM3 3h1v1H3zM0 4h1v1H0zM4 4h1v1H4z';

  const svg =
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-0.75 -0.75 6.5 6.5'>` +
    `<rect x='-0.75' y='-0.75' width='6.5' height='6.5' fill='hsl(${hue},30%,15%)'/>` +
    `<path fill='hsl(${hue},${sat}%,${lit}%)' d='${d}'/></svg>`;
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
};

export const isDicebearUrl = (url) => /dicebear\.com/i.test(String(url || ''));

export const displayAvatar = (photoURL, seed) =>
  !photoURL || isDicebearUrl(photoURL) ? identiconDataUri(seed) : photoURL;
